import Vue from 'vue';
import desktopEmbed from './desktop-embed';
import VisualizadorArquivo from '../componentes/VisualizadorArquivo.vue';

function visualizavel(tipo) {
  return tipo === 'application/pdf' || /^image\/(png|jpeg|gif|bmp|webp)$/.test(tipo);
}

export function baixarBlob(blob, nome) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

function mostrarNaTela(blob, nome, tipo) {
  const url = URL.createObjectURL(blob);
  const alvo = document.createElement('div');
  document.body.appendChild(alvo);

  const instancia = new Vue({
    render: h => h(VisualizadorArquivo, {
      props: { url, nome, tipo },
      on: {
        baixar: () => baixarBlob(blob, nome),
        fechar: () => {
          instancia.$destroy();
          if (instancia.$el && instancia.$el.parentNode) instancia.$el.parentNode.removeChild(instancia.$el);
          URL.revokeObjectURL(url);
        },
      },
    }),
  }).$mount(alvo);
}

export function abrirBlob(blob, nome) {
  const tipo = (blob && blob.type) || '';

  if (!visualizavel(tipo)) {
    baixarBlob(new Blob([blob], { type: 'application/octet-stream' }), nome);
    return;
  }

  if (desktopEmbed.disponivel()) {
    mostrarNaTela(blob, nome, tipo);
    return;
  }

  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
}

export function dicaAbrir() {
  return desktopEmbed.disponivel()
    ? 'Abrir o arquivo (PDF e imagem abrem aqui mesmo; os demais são baixados)'
    : 'Abrir o arquivo (PDF e imagem abrem numa aba nova; os demais são baixados)';
}



// WEBPACK FOOTER //
// ./FrontEnd/js/abrir-arquivo.js